import { render, staticRenderFns } from "./quest-evaluation.vue?vue&type=template&id=a0f72888&scoped=true"
import script from "./quest-evaluation.vue?vue&type=script&lang=js"
export * from "./quest-evaluation.vue?vue&type=script&lang=js"
import style0 from "./quest-evaluation.vue?vue&type=style&index=0&id=a0f72888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f72888",
  null
  
)

export default component.exports